import { WorksheetsEnvironment } from 'printableWorksheets'
import CircleAnimation from 'printableWorksheets/atoms/CircleLoader/CircleLoader'
import { usePrintableWorksheetsState } from 'printableWorksheets/state'
import React, { useCallback, useEffect, useMemo } from 'react'
import WorksheetsNotFound from '../../../teacherDashboard/teacher/components/printable_worksheets/worksheets-not-found'
import WorksheetsNav from '../worksheetsNav'
import WorksheetsView from '../worksheetsView'
import WSTeacherHeader from '../worksheetsView/wsTeacherHeader'
import './styles.scss';
import PrintableWorksheetsEvents from 'printableWorksheets/events'
import { freeWsDownloadLeft } from 'apps/teacher/config/common'
import { getFromPage } from '../../../teacherDashboardIA/utils'

const Printables = ({ }) => {

  const { defaultSearch, worksheetsEnvironment, isWorksheetsLoading, ineligibleGrade, activeGrade } = usePrintableWorksheetsState();
  const isTeacherEnvironment = useMemo(() => worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD, [worksheetsEnvironment]);

  const renderTeacherEnvironment = useMemo(() => {
    if (ineligibleGrade) {
      return <WorksheetsNotFound/>
    } else {
      return <>
      <div className={`printable-worksheets__top${!defaultSearch ? ' un-focus' : ''}`}>
        <WSTeacherHeader />
      </div>
      <div className="printable-worksheets__bottom">
        <div className={`printable-worksheets__left${!defaultSearch ? ' un-focus' : ''}`}>
          <WorksheetsNav />
        </div>
        <div className="printable-worksheets__right">
          <WorksheetsView />
        </div>
      </div>
    </>
    }
  }, [ineligibleGrade]);

  useEffect(() => {
    PrintableWorksheetsEvents.viewedWorksheetListingPage({
      fromPage: getFromPage(),
      worksheetGrade: activeGrade,
      freeWorksheetsLeftCount: freeWsDownloadLeft()
    });
  }, []);

  const toRender = useMemo(() => {
    return isWorksheetsLoading ? (
      <div className="ws-loader-container">
        <CircleAnimation />
      </div>
    ) : (
      <>
        {isTeacherEnvironment ? renderTeacherEnvironment : (
          <>
            <div className={`printable-worksheets__left${!defaultSearch ? ' un-focus' : ''}`}>
              <WorksheetsNav />
            </div>
            <div className="printable-worksheets__right student-env" id="ws-right-div">
              <WorksheetsView />
            </div>
          </>
        )}
      </>
    )
  }, [isWorksheetsLoading, isTeacherEnvironment])

  return toRender;
}

export default Printables